module.exports = __webpack_public_path__ + "media/images/common/ico-lp-about-easy-bf8d917e7a6ea3d725e102af7c78fd49.svg";